import PoliciesIndex from '@/views/PoliciesIndex.vue';
import PoliciesCreate from '@/views/PoliciesCreate.vue';

const routes = [
    {
        path: '/policy-exceptions',
        name: 'PoliciesIndex',
        component: PoliciesIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/policy-exceptions/create',
        name: 'PoliciesCreate',
        component: PoliciesCreate,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
